import { useMemo } from 'react';
import { useTrackedPageContext } from 'src/context/trackedPage';
import {
  AnalyticsDataEvent,
  AnalyticsDataMediaType,
  AnalyticsDataProperty,
  AnalyticsDataVideoAction,
  AnalyticsEventLearnableSnippet,
} from 'src/types/googleAnalyticsEvents';

type MediaData = {
  title: string;
  url: string;
};

export function useEventLearnableSnippet(
  mediaType: AnalyticsDataMediaType,
  { title, url }: MediaData,
): AnalyticsEventLearnableSnippet {
  const trackedPageContext = useTrackedPageContext();

  return useMemo(
    () => ({
      [AnalyticsDataProperty.event]: AnalyticsDataEvent.learnableSnippet,
      [AnalyticsDataProperty.mediaType]: mediaType,
      [AnalyticsDataProperty.mediaUrl]: url,
      [AnalyticsDataProperty.videoAction]: AnalyticsDataVideoAction.start,
      [AnalyticsDataProperty.videoName]: title,
      ...trackedPageContext,
    }),
    [mediaType, title, trackedPageContext, url],
  );
}
